import { useState } from 'react';
import { Button, Dialog, Field, Input } from '@/components/ui';

/**
 * RL-1837: cancel a signed prescription with a reason (3–300 characters, as
 * the API keeps). Its app requests close with it and an issued pharmacy
 * prescription is revoked; once dispensed, cancelling stops its refills.
 */
export function CancelPrescriptionDialog({
  number,
  pending,
  onCancel,
  onClose,
}: {
  number: string | null;
  pending: boolean;
  onCancel: (reason: string) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState('');
  const ready = reason.trim().length >= 3;
  return (
    <Dialog
      open
      variant="modal"
      title={`Cancel prescription ${number ?? ''}`.trim()}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Keep it</Button>
          <Button
            variant="danger"
            disabled={!ready}
            loading={pending}
            onClick={() => onCancel(reason.trim())}
          >
            Cancel prescription
          </Button>
        </>
      }
    >
      <p>
        It leaves the dispensary list and the patient’s app. Refill or
        outside-pharmacy requests from the app close with it, and an issued
        pharmacy prescription stops being valid. If the medicines were already
        dispensed, it stops any further refills.
      </p>
      <Field
        label="Reason"
        hint="At least 3 characters. Kept with the prescription."
      >
        <Input
          value={reason}
          maxLength={300}
          onChange={(e) => setReason(e.target.value)}
        />
      </Field>
    </Dialog>
  );
}
